module.exports = __webpack_public_path__ + "media/images/patent/z_3-d1158efd070d06c7ad9f3520af0f213e.png";